<template>
  <Dialog
    :open="open"
    class="relative z-[100]"
    data-test-id="giftcard-preview-sheet"
    @close="emit('close')"
  >
    <DialogPanel class="fixed inset-0 flex flex-col bg-white">
      <div
        class="relative flex items-center justify-center border-b border-gray-200 px-4 py-4"
      >
        <DialogTitle class="text-base font-semibold text-stone-800">
          {{ t('personalization.theme.preview.title') }}
        </DialogTitle>
        <button
          type="button"
          class="absolute right-4 h-5 w-5 [&_path]:fill-stone-800"
          :aria-label="t('personalization.theme.preview.close')"
          data-test-id="giftcard-preview-sheet-close"
          @click="emit('close')"
        >
          <IconClose class="h-full w-full" />
        </button>
      </div>

      <div class="flex-1 overflow-y-auto px-4 py-4">
        <p class="mb-3 text-center text-sm text-stone-600">
          {{ t('personalization.theme.preview.subtitle') }}
        </p>
        <slot />
        <p class="mt-4 mb-3 text-base text-stone-800">
          <span class="font-semibold">
            {{ t('personalization.theme.steps.design') }}
          </span>
          · {{ designName }}
        </p>
        <slot name="designs" />
      </div>

      <div class="border-t border-gray-200 px-4 pt-3 pb-8">
        <Button
          class="w-full"
          data-test-id="giftcard-preview-sheet-keep-editing"
          @click="emit('close')"
        >
          {{ t('personalization.theme.preview.keepEditing') }}
        </Button>
      </div>
    </DialogPanel>
  </Dialog>
</template>

<script setup lang="ts">
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/vue'
import IconClose from '~/assets/icons/icon-close.svg?component'

defineProps<{
  open: boolean
  designName: string
}>()

const emit = defineEmits<{
  close: []
}>()

const { t } = useI18n()
</script>
